// extracted by mini-css-extract-plugin
export default {"spinner":"NewCompany-spinner___GUcQJ","error":"NewCompany-error___Qh1O3"};